/**
 * PopupCtrl controller
 * Show popup from raw text
 */

/**
 * PopupCtrl controller
 *
 * @class PopupCtrl
 * @memberof mwApp/common
 * @see mwApp/common
 *
 * @ngdoc controller
 * @name mwApp/common.controller:PopupCtrl
 */
/* @ngInject */
export default function PopupCtrl ($uibModalInstance, text, props) {
  const vm = this

  vm.props = props

  vm.lines = text.split('\n').map((text, index) => ({ text, index })).filter(t => t.text !== '')

  vm.moreLines = false

  /**
   * Cancel, close modal window
   *
   * @memberof mwApp/common.controller:PopupCtrl
   */
  vm.cancel = function () {
    $uibModalInstance.dismiss('cancel')
  }
}
